import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import { TWENTY_FOUR_HOURS_IN_MILLISECONDS } from '../../../config/constants';

import {
    TimeLeftBold,
    SpecialCountdown
} from '../../shared/Shared';

import Discount from './Discount';
import styles from './CampaignInfo.scss';

export const CampaignInfo = ({ campaign, dimension, discount }) => {
    const thresholdForSpecialTimer = Date.now() + TWENTY_FOUR_HOURS_IN_MILLISECONDS;

    return (
        <div styleName={classNames('info', `info-${dimension}`)}>
            <div styleName="info-wrapper">
                { campaign.options && campaign.options.specialTimer && (campaign.dateEnd <= thresholdForSpecialTimer)
                    ? <SpecialCountdown dateTill={ campaign.dateEnd } />
                    : <div styleName="regular-info">
                        <TimeLeftBold dateTill={campaign.dateEnd} isOpen />
                        <Discount
                            campaign={campaign}
                            discount={discount}
                        />
                    </div>
                }
            </div>
        </div>
    );
};

CampaignInfo.propTypes = {
    discount: PropTypes.string.isRequired,
    dimension: PropTypes.string.isRequired,
    campaign: PropTypes.object.isRequired
};


export default CSSModules(CampaignInfo, styles, { allowMultiple: true });
